import { useEffect, useState } from "react";
import { ShieldAlert, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { getPitchingQueue } from "@/lib/afmApi";
import { Loading, SectionTitle } from "@/components/common";

const scoreCls = (s) => (s >= 75 ? "bg-emerald-50 text-emerald-700 border-emerald-300" : s >= 50 ? "bg-amber-50 text-amber-700 border-amber-300" : "bg-red-50 text-red-700 border-red-300");

export default function AdminPitching() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    getPitchingQueue(user.id)
      .then((d) => {
        const evs = d?.evaluations || [];
        evs.sort((a, b) => (b.fit_score || 0) - (a.fit_score || 0));
        setItems(evs); setStatus("ok");
      })
      .catch((e) => { setMsg(e?.response?.data?.detail || "Acceso restringido"); setStatus("denied"); });
  }, [user.id]);

  if (status === "loading") return <Loading />;
  if (status === "denied") return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white py-20 text-center" data-testid="admin-denied">
      <div className="mb-4 rounded-full border border-amber-300 bg-amber-50 p-4 text-amber-700"><ShieldAlert className="h-7 w-7" /></div>
      <h3 className="font-serif text-xl font-bold text-black">Solo administradores</h3>
      <p className="mt-2 max-w-sm text-sm text-slate-500">{msg}</p>
    </div>
  );

  return (
    <div className="space-y-6" data-testid="admin-pitching-page">
      <SectionTitle>Cola de Pitching IA</SectionTitle>
      <div className="space-y-3">
        {items.map((e) => (
          <div key={e.release_id} className="rounded-xl border border-slate-200 bg-white p-5" data-testid={`pitch-row-${e.release_id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <Sparkles className="h-4 w-4 text-[#AC3333]" />
                  <h3 className="font-serif text-lg font-bold text-black">{e.title}</h3>
                </div>
                <div className="mt-1 text-xs text-slate-500">{e.user_id} · {e.model}</div>
              </div>
              <div className={`shrink-0 rounded-full border px-3 py-1.5 text-sm font-bold tabular-nums ${scoreCls(e.fit_score || 0)}`}>Fit {e.fit_score ?? "—"}</div>
            </div>
            {(e.mood_tags || []).length > 0 && (
              <div className="mt-3 flex flex-wrap gap-1.5">
                {e.mood_tags.map((t, i) => <span key={i} className="rounded-full bg-slate-100 px-2.5 py-0.5 text-[11px] font-medium text-slate-600">{t}</span>)}
              </div>
            )}
            {(e.playlist_fit || []).length > 0 && (
              <div className="mt-3 border-t border-slate-100 pt-3">
                <div className="mb-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-400">Playlists sugeridas</div>
                <ul className="space-y-1 text-sm text-slate-700">
                  {e.playlist_fit.slice(0, 5).map((p, i) => <li key={i} className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-[#AC3333]" /> {p}</li>)}
                </ul>
              </div>
            )}
          </div>
        ))}
        {!items.length && <p className="py-16 text-center text-sm text-slate-400">No hay evaluaciones en la cola.</p>}
      </div>
    </div>
  );
}
